import { useState } from "react";

import Joi from "joi-browser";

import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { Button } from "V2.0/common/button";

const schema = {
  parameterName: Joi.string().required().max(50).label("Name"),
  parameterDescription: Joi.string().required().max(600).label("Description"),
  parameterType: Joi.string().required().max(300).label("Type of field"),
  parameterChoices: Joi.array().items(Joi.string()).required(),
  isMandatoryField: Joi.boolean().required().label("Mandatory Field"),
};

function ExtractionParameterForm(props) {
  const { extractionParameter, onSave, onCancel } = props;

  const inputField = {
    parameterName: extractionParameter.parameterName,
    parameterDescription: extractionParameter.parameterDescription,
    parameterType: extractionParameter.parameterType,
    parameterChoices: extractionParameter.parameterChoices,
    isMandatoryField: extractionParameter.isMandatoryField,
  };

  const { data, handleChange, validate, error, setError } = useForm(
    inputField,
    schema,
    false
  );

  const handleSave = () => {
    const errors = validate(data, schema);

    if (errors) {
      setError(errors);
      return;
    }

    onSave(data);
    onCancel();
  };

  const template = [
    {
      name: "parameterName",
      label: "Name of the extracted field",
      type: "text",
    },
    {
      name: "isMandatoryField",
      label: "Mandatory Field",
      type: "toggle",
    },
    {
      name: "parameterType",
      label: "Choose type of field",
      type: "radio",
      options: [
        { id: 1, value: "boolean", label: "Yes/No Field" },
        { id: 2, value: "open", label: "Open answer" },
        { id: 3, value: "choice", label: "Choice field" },
      ],
    },
    {
      name: "parameterDescription",
      label: "Describe what the AI should extract.",
      type: "textArea",
      style: { height: "250px", fontSize: "13px" },
    },
    data.parameterType === "choice" && {
      name: "parameterChoices",
      label: "Provide a list of options for the AI to select from",
      type: "inputFieldList",
    },
  ];

  return (
    <div>
      <Form
        data={data}
        template={template}
        error={error}
        handleChange={handleChange}
      />
      <div className="flex justify-end gap-x-2">
        <Button outline onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={handleSave}>Save</Button>
      </div>
    </div>
  );
}

export { ExtractionParameterForm };
